var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-container" },
    [
      _c(
        "div",
        { staticClass: "admin-content-container" },
        [
          [
            _c("div", { staticClass: "bar-row" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: {
                        disabled:
                          (_vm.chooseable && !!_vm.multiChoose.mode) ||
                          !_vm.hasPermission("download"),
                        icon: "el-icon-download",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toogleMultiSelect("download")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("BATCH_DOWNLOAD")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "wl-search-bar" },
                [
                  _vm.isKpmgUser
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green mgr10",
                          attrs: { icon: "el-icon-plus" },
                          on: { click: _vm.toggleAddVisible },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("COMMON_ADD")) +
                              "\n                  "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green svg-btn",
                      attrs: { disabled: !_vm.hasPermission("download") },
                      on: { click: _vm.exportList },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("Export_exchange_Items")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                class: [
                  "table-container-wrapper",
                  _vm.chooseable ? "show-table-bottom-operate" : "",
                ],
              },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "exchangeTable",
                    staticClass: "exchange-table",
                    attrs: {
                      height: "100%",
                      data: _vm.data,
                      border: "",
                      stripe: "",
                    },
                    on: {
                      "select-all": (e) => _vm.handleSelectAll(e, _vm.data),
                      select: _vm.handleSelect,
                    },
                  },
                  [
                    _vm.chooseable
                      ? _c("el-table-column", {
                          attrs: { type: "selection", width: "50" },
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      key: 1,
                      attrs: {
                        prop: "entityName",
                        width: "500",
                        label: _vm.$t("admin.entityName"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm.isKpmgUser
                                      ? _c(
                                          "el-dropdown",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px",
                                            },
                                            attrs: { trigger: "click" },
                                            on: {
                                              "visible-change": _vm.change,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "el-dropdown-link",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-edit-outline table-header-edit-cls table-header-blue-icon",
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-menu",
                                              {
                                                attrs: { slot: "dropdown" },
                                                slot: "dropdown",
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    size: "mini",
                                                    placeholder:
                                                      _vm.$t(
                                                        "admin.entityName"
                                                      ),
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value: _vm.batchEntityName,
                                                    callback: function ($$v) {
                                                      _vm.batchEntityName = $$v
                                                    },
                                                    expression:
                                                      "batchEntityName",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.$t("admin.entityName")) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value: _vm.searchForm.entityName,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "entityName",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c(
                              "div",
                              { staticClass: "table-cell" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.entityName,
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-with-icon" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(scope.row.entityName) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm.isKpmgUser
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-edit table-header-blue-icon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUpdateEntityNameClick(
                                            scope.row,
                                            "entityName"
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 2,
                      attrs: {
                        prop: "description",
                        "min-width": "300",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.description"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c(
                              "div",
                              { staticClass: "table-cell w-full" },
                              [
                                scope.row.messageNum > 0
                                  ? _c(
                                      "el-popover",
                                      {
                                        staticClass: "text-with-icon",
                                        attrs: {
                                          placement: "top",
                                          width: "700",
                                          trigger: "hover",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          _vm._l(
                                            scope.row.messageList,
                                            function (v, k) {
                                              return _c("div", { key: k }, [
                                                _vm._v(
                                                  "\n                                      【\n                                      "
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(v.sendUserName) + " "
                                                  ),
                                                ]),
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatDateTime"
                                                        )(v.updateDate)
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _vm._v(
                                                  "\n                                      】\n                                      "
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(v.messageContent)
                                                  ),
                                                ]),
                                                _c("br"),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "table-td-comment",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.messageList[0]
                                                    .messageContent
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isKpmgUser
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-edit table-header-blue-icon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUpdateEntityNameClick(
                                            scope.row,
                                            "description"
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          },
                        },
                      ]),
                    }),
                    _c(
                      "el-table-column",
                      {
                        key: 3,
                        attrs: {
                          prop: "signingDate",
                          width: "120",
                          "show-overflow-tooltip": "",
                          label: _vm.$t("admin.signingDate"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        scope.row.signingDate
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c(
                            "div",
                            { staticClass: "header-with-popup" },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("admin.signingDate")) +
                                  "\n                                "
                              ),
                              _c("DatePickerPopover", {
                                attrs: {
                                  value: _vm.searchForm.signingDateRange,
                                  hidePopperSearch: _vm.hidePopperSearch,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    return _vm.$set(
                                      _vm.searchForm,
                                      "signingDateRange",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                    _c("el-table-column", {
                      key: 4,
                      attrs: {
                        prop: "contractType",
                        "min-width": "200",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("admin.contractType")) +
                                      "\n                                "
                                  ),
                                  _c("MultiSelectPopver", {
                                    attrs: {
                                      hidePopperSearch: _vm.hidePopperSearch,
                                      value: _vm.searchForm.contractTypeList,
                                      labelKey: "label",
                                      valueKey: "value",
                                      inputFilterKey: ["label", "value"],
                                      options: _vm.categoryOptions,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        return _vm.$set(
                                          _vm.searchForm,
                                          "contractTypeList",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(
                                    _vm.$t(`admin.${scope.row.contractType}`)
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 5,
                      attrs: { prop: "fileList", width: "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-with-popup header-one-center",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("admin.contract")) +
                                      "\n                                "
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "reference",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "th-filter-down",
                                                },
                                                [
                                                  _c("i", {
                                                    class: [
                                                      "el-icon-arrow-down",
                                                      _vm.searchForm
                                                        .searchContent
                                                        ? "el-icon-arrow-down-active"
                                                        : "",
                                                    ],
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      [
                                        _c("el-input", {
                                          staticClass: "input-with-select",
                                          attrs: {
                                            size: "medium",
                                            placeholder:
                                              _vm.$t("fileNameKeyword"),
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.searchForm.searchContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.searchForm,
                                                "searchContent",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchForm.searchContent",
                                          },
                                        }),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.fileList &&
                              scope.row.fileList.length > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "file-number-hint",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toogleFileDetailVisible(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(scope.row.fileList.length) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.isKpmgUser
                      ? _c("el-table-column", {
                          key: 6,
                          attrs: {
                            width: "100",
                            label: _vm.$t("COMMON_UPLOAD"),
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    !_vm.isIE
                                      ? _c("i", {
                                          class: [
                                            "el-icon-upload",
                                            !_vm.hasPermission("upload")
                                              ? "wl-icon-messageBoardNull"
                                              : "wl-icon-messageBoard",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.toogleUploadVisible(
                                                scope.row
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "el-button",
                                          {
                                            class: [
                                              "el-icon-upload",
                                              !_vm.hasPermission("upload")
                                                ? "upload-forbid"
                                                : "wl-green",
                                            ],
                                            attrs: {
                                              size: "mini",
                                              disabled:
                                                !_vm.hasPermission("upload"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toogleUploadVisible(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("COMMON_UPLOAD"))
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3074132769
                          ),
                        })
                      : _vm._e(),
                    _vm.isKpmgUser
                      ? _c("el-table-column", {
                          key: 9,
                          attrs: {
                            width: "100",
                            label: _vm.$t("TABLE_HEADER_Action"),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-delete wl-icon-delete",
                                        staticStyle: { "margin-left": "10px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(scope.row)
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            57749797
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.chooseable
              ? _c(
                  "div",
                  { staticClass: "footer-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancel-btn",
                        attrs: { disabled: !_vm.chooseable },
                        on: { click: _vm.cancelChoose },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("btn_cancel")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm.chooseable && _vm.multiChoose.mode == "download"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.tooglebatchDownLoad("download")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("COMMON_DOWNLOAD")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-pagination",
              {
                staticClass: "wl-pagination",
                attrs: {
                  "current-page": _vm.pagination.pageNum,
                  "page-size": _vm.pagination.pageSize,
                  layout: "prev, pager, next, slot, total",
                  total: _vm.pagination.total,
                },
                on: {
                  "current-change": _vm.onCurrentPageChange,
                  "size-change": _vm.onSizeChange,
                },
              },
              [
                _c(
                  "span",
                  [
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.onSizeChange },
                        model: {
                          value: _vm.pagination.pageSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.pagination, "pageSize", $$v)
                          },
                          expression: "pagination.pageSize",
                        },
                      },
                      _vm._l(_vm.pageOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _vm.updateEntityOption.show
        ? _c("UpdateEntityName", {
            attrs: {
              show: _vm.updateEntityOption.show,
              onConfirm: _vm.confirmUpdateEntityName,
              value: _vm.updateEntityOption.value,
              type: _vm.updateEntityOption.type,
            },
            on: { close: _vm.closeUpdateEntityName },
          })
        : _vm._e(),
      _vm.addVisible
        ? _c("admin-add", {
            attrs: {
              saveLoading: _vm.btnLoading,
              initData: _vm.initData,
              onCancel: _vm.toggleAddVisible,
              categoryOptions: _vm.categoryOptions,
              type: "contract",
              onAdd: _vm.saveContractItem,
            },
          })
        : _vm._e(),
      _vm.uploadVisible
        ? _c("upload", {
            attrs: {
              initData: _vm.rowData,
              onCancel: _vm.closeUploadVisble,
              onAdd: _vm.uploadSuccess,
              source: "contract",
            },
          })
        : _vm._e(),
      _vm.fileDetailVisbile
        ? _c("file-detail", {
            attrs: {
              id: _vm.rowData.id,
              tableData: _vm.rowData.fileList,
              curUserName: _vm.curUserName,
              activeTab: "contract",
              downloadAble: _vm.downloadAble,
              onCancel: _vm.toogleFileDetailVisible,
            },
            on: { "on-file-download": _vm.downloadFileDetail },
          })
        : _vm._e(),
      _c("file-confirm-modal", {
        ref: "FileConfirmModal",
        attrs: {
          fileDownloading: _vm.fileDownloading,
          groupList: _vm.hasSelectedList,
          curUserName: _vm.curUserName,
          downloadAble: _vm.downloadAble,
          mode: _vm.downloadDialogMode,
        },
        on: {
          ok: _vm.downloadMultipleFiles,
          "on-file-download": _vm.downloadFileDetail,
          updateMultipleSelection: _vm.updateMultipleSelection,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }